// ─── Events ──────────────────────────────────────────────────────────────────

export type AuthEvent =
  | { type: 'LOGIN'; postLoginRedirectHref?: string }
  | { type: 'LOGOUT' }
  | { type: 'RETRY_SESSION' }
  | { type: 'CLEAR_POST_LOGIN_REDIRECT_HREF' };
